import { useCallback } from "react";
import axiosConfig from "../../axiosConfig";
import sanitizeDirectoryStructure from "../utils/sanitizeDirectoryStructure";

const useMessagesApi = () => {
  const fetchMessages = useCallback(async () => {
    return axiosConfig.get("/outbox/get-messages");
  }, []);

  const fetchMessageDetails = useCallback(async (messageId) => {
    return axiosConfig.get(`outbox/edit/get-details/${messageId}`);
  }, []);

  const createMessage = useCallback(async (payload) => {
    return axiosConfig.post("outbox/create", payload);
  }, []);

  const updateMessage = useCallback(async (messageId, payload) => {
    return axiosConfig.post(`outbox/edit/${messageId}`, payload);
  }, []);

  const deleteMessage = useCallback(async (messageId) => {
    return axiosConfig.post(`outbox/delete-message/${messageId}`);
  }, []);

  const fetchOutboxFolderStructure = useCallback(async () => {
    const response = await axiosConfig.get("/outbox/get-folder-structure");
    const { directoryStructure } = response.data || {};
    return sanitizeDirectoryStructure(directoryStructure || {});
  }, []);

  return {
    fetchMessages,
    fetchMessageDetails,
    createMessage,
    updateMessage,
    deleteMessage,
    fetchOutboxFolderStructure,
  };
};

export default useMessagesApi;

